// src/layouts/SekolahLayout.jsx

import React from "react";
import { AppShell } from "@mantine/core";
import { Routes, Route, Navigate } from "react-router-dom"; // Import Navigate

// Komponen UI
import { NavbarMinimal } from "../components/NavbarMinimal";
import { HeaderMegaMenu } from "../components/HeaderMegaMenu";
import { FooterSimple } from "../components/FooterSimple";

// Halaman
import DashboardSekolah from "../pages/sekolah/SekolahDashboardPage";
import KonfirmasiPage from "../pages/sekolah/KonfirmasiPage";

export default function SekolahLayout() {
  return (
    <AppShell
      padding="md"
      header={{ height: 60 }}
      navbar={{ width: 80, breakpoint: "sm" }}
      footer={{ height: 50 }}
    >
      <AppShell.Header>
        <HeaderMegaMenu />
      </AppShell.Header>

      <AppShell.Navbar p={0}>
        <NavbarMinimal />
      </AppShell.Navbar>

      <AppShell.Footer p={0}>
        <FooterSimple />
      </AppShell.Footer>

      <AppShell.Main>
        <Routes>
          {/* Halaman Dashboard */}
          <Route path="dashboard" element={<DashboardSekolah />} />
          <Route path="/konfirmasi" element={<KonfirmasiPage />} />
        </Routes>
      </AppShell.Main>
    </AppShell>
  );
}
